// extracted by mini-css-extract-plugin
export default {"container":"Searching_container__XKrv4","link":"Searching_link__2iNcb"};